import React from 'react';
import { ShieldCheck, QrCode, FileSpreadsheet, Bell } from 'lucide-react';

export const FeatureHighlightsGrid: React.FC = () => {
  return (
    <section className="w-full max-w-7xl 2xl:max-w-[1536px] 3xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 2xl:gap-6">
        <div className="p-6 2xl:p-7 bg-white rounded-3xl border border-slate-200/90 shadow-2xs space-y-3 hover:border-indigo-300 transition">
          <div className="w-10 h-10 2xl:w-12 2xl:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 2xl:w-7 2xl:h-7" />
          </div>
          <h4 className="font-bold text-slate-900 text-base sm:text-lg lg:text-xl 2xl:text-2xl">Algoritma Checksum</h4>
          <p className="text-xs sm:text-sm lg:text-base 2xl:text-[16px] text-slate-600 leading-relaxed">
            Validasi modulo-10 mencegah kesalahan ketik dan memastikan keaslian setiap nomor unik UIBN.
          </p>
        </div>

        <div className="p-6 2xl:p-7 bg-white rounded-3xl border border-slate-200/90 shadow-2xs space-y-3 hover:border-indigo-300 transition">
          <div className="w-10 h-10 2xl:w-12 2xl:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
            <QrCode className="w-6 h-6 2xl:w-7 2xl:h-7" />
          </div>
          <h4 className="font-bold text-slate-900 text-base sm:text-lg lg:text-xl 2xl:text-2xl">Barcode & QR Code</h4>
          <p className="text-xs sm:text-sm lg:text-base 2xl:text-[16px] text-slate-600 leading-relaxed">
            Generator instan barcode Code128 / EAN13 dan QR code 2D yang dapat langsung diunduh format SVG & PNG.
          </p>
        </div>

        <div className="p-6 2xl:p-7 bg-white rounded-3xl border border-slate-200/90 shadow-2xs space-y-3 hover:border-indigo-300 transition">
          <div className="w-10 h-10 2xl:w-12 2xl:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
            <FileSpreadsheet className="w-6 h-6 2xl:w-7 2xl:h-7" />
          </div>
          <h4 className="font-bold text-slate-900 text-base sm:text-lg lg:text-xl 2xl:text-2xl">Ekspor Data CSV</h4>
          <p className="text-xs sm:text-sm lg:text-base 2xl:text-[16px] text-slate-600 leading-relaxed">
            Dukungan ekspor seluruh data katalog buku ke file CSV standar Excel dengan encoding UTF-8 BOM.
          </p>
        </div>

        <div className="p-6 2xl:p-7 bg-white rounded-3xl border border-slate-200/90 shadow-2xs space-y-3 hover:border-indigo-300 transition">
          <div className="w-10 h-10 2xl:w-12 2xl:h-12 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center">
            <Bell className="w-6 h-6 2xl:w-7 2xl:h-7" />
          </div>
          <h4 className="font-bold text-slate-900 text-base sm:text-lg lg:text-xl 2xl:text-2xl">Notifikasi Push</h4>
          <p className="text-xs sm:text-sm lg:text-base 2xl:text-[16px] text-slate-600 leading-relaxed">
            Pemberitahuan otomatis ke penulis & penerbit saat status buku diverifikasi atau berubah.
          </p>
        </div>
      </div>
    </section>
  );
};
